export * from './video-player.component';
